/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { headerActualDetailConfig } from '../../config/header.config';
export interface IHeaderActualDetailPluginMethods extends IPluginMethodMap {
  getHeaderActualDetailSync(args?: any): any;
}

export class HeaderActualDetailPlugin implements IAgentPlugin {
  readonly methods: IHeaderActualDetailPluginMethods;

  constructor() {
    this.methods = {
      getHeaderActualDetailSync: this.getHeaderActualDetailSync.bind(this),
    };
  }

  getHeaderActualDetailSync(args?: any) {
    return {
      header: headerActualDetailConfig,
    };
  }
}
